export default __webpack_public_path__ + "static/media/http_suecess.4be0e147.png";